import React, { useState, useEffect, useRef, useCallback } from 'react';
import Grid from '@mui/material/Grid2';

import { Character } from "@dndModels/character";

interface Props { 
  character: Character;
}

export default function CharacterProficiencyBonus({
  character,
}: Props) {
  const [pb, setPB] = useState(0);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculated = useCallback(() => {
    setTimeout(() => {
      setPB(character.proficiency_modifier);
    }, 100);
  }, [character]);

  useEffect(() => {
    character.subscription_holder.subscribe("Recalculated", mounted, recalculated);
    recalculated();
  }, [character, recalculated]);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <div className="centered" style={{
          fontSize: "11px",
          fontWeight: "bold",
        }}>
          Proficiency
        </div>
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <div className="centered" style={{
          fontSize: "24px",
          fontWeight: "bold",
        }}>
          +{ pb }
        </div>
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <div className="centered" style={{
          fontSize: "11px",
          fontWeight: "bold",
        }}>
          Bonus
        </div>
      </Grid>
    </Grid>
  );
}
